import asyncActionTypes from '../../actions/types';

const initialState = {
  openCbxModal: false,
};

const cbxModal = (state = initialState, action) => {
  if (action.type === asyncActionTypes.SET_CBX_MODAL) {
    return {
      ...state,
      openCbxModal: action.cbx,
    };
  } else {
    return state;
  }
};

export default cbxModal;
